import { useMutation } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export interface RetriggerDeliveryResult {
  status: 'queued' | 'already_queued' | 'not_replayable';
}

export const useRetriggerDeliveryTRPC = () => {
  const trpc = useTRPC();
  // No onSuccess invalidation: the re-queued row only appears ~1 min later
  // (retry sweeper), so refetching now shows nothing new.
  const mutation = useMutation(
    trpc.frontend.webhook.retriggerDelivery.mutationOptions()
  );

  return {
    retriggerDelivery: async (id: string): Promise<RetriggerDeliveryResult> => {
      const result = await mutation.mutateAsync({ id });

      return { status: result.status };
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
